const loanProductTypes = [
  {
    value: 'LOAN',
    labelKey: 'Product type Loan',
  },
];

const loanRequestCurrencies = [
  { value: 'TJS', label: 'TJS' },
  { value: 'USD', label: 'USD' },
  { value: 'RUB', label: 'RUB' },
  { value: 'EUR', label: 'EUR' },
];

const loanRequestDocuments = [
  {
    name: 'bank_form',
    labelKey: 'Document bank form',
  },
  {
    name: 'balance',
    labelKey: 'Document balance',
  },
  {
    name: 'passports',
    labelKey: 'Document passports',
  },
  {
    name: 'contracts',
    labelKey: 'Document contracts',
  },
  {
    name: 'feasibility_study',
    labelKey: 'Document feasibility study',
  },
];

const LOAN_REQUEST_FILE_MAX_MB = 10;
const LOAN_REQUEST_FILE_ACCEPT = '.pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx';
const LOAN_REQUEST_FILE_FORMATS = 'PDF, JPG, PNG, DOC, XLS';

export {
  loanProductTypes,
  loanRequestCurrencies,
  loanRequestDocuments,
  LOAN_REQUEST_FILE_MAX_MB,
  LOAN_REQUEST_FILE_ACCEPT,
  LOAN_REQUEST_FILE_FORMATS,
};
